<template>
  <b-button-toolbar class="ml-1 mt-1">
    <b-btn variant="primary" class="mr-1" @click="$emit('submit')" :disabled="SubmitText() === 'SOUMIS'">
      {{ SubmitText() }}
    </b-btn>
  </b-button-toolbar>
</template>

<script>
import {LocalID, Textes} from "@/js/caller";

export default {
  name: "lpButtonToolbar",
  props: {
    exercice: Object,
    access:Boolean,
  },
  methods: {
    SubmitText() {
      const {exercice, access} = this
      return !exercice.texte_id ? "SOUMETTRE" :
          (LocalID.isLocalID(exercice.texte_id) && !access ? "S'INSCRIRE" : "SOUMIS");
    }
  },
  async created() {
    const {exercice} = this;
    const textes = await Textes.GetList({Equal: [{field: "exercice", value: exercice.id}]}, true);
    if (textes.length) {
      exercice.texte_id = textes[0].id
    }
  }
}
</script>

<style scoped>

</style>